import { useState, useEffect } from 'react';
import { api } from '../services/apiClient';
import { DEFAULT_DAILY_LIMIT, DEFAULT_LIMITS } from '../constants';

const DEFAULT_SCAN_SCHEDULES = [
  { id: 'default', time: '23:00', days: ['all'], enabled: true },
];

export function useSettings() {
  const [settings, setSettings] = useState({
    dailyLimit: DEFAULT_DAILY_LIMIT,
    dailyVatMin: DEFAULT_LIMITS.dailyVatMin,
    dailyVatMax: DEFAULT_LIMITS.dailyVatMax,
    scanSchedules: DEFAULT_SCAN_SCHEDULES,
  });
  const [apiOk, setApiOk] = useState(false);

  useEffect(() => {
    api.health().then(() => setApiOk(true)).catch(() => setApiOk(false));
    api.getSettings()
      .then(s => setSettings({
        dailyLimit: DEFAULT_DAILY_LIMIT,
        dailyVatMin: DEFAULT_LIMITS.dailyVatMin,
        dailyVatMax: DEFAULT_LIMITS.dailyVatMax,
        scanSchedules: DEFAULT_SCAN_SCHEDULES,
        ...s,
      }))
      .catch(() => {});
  }, []);

  return { settings, setSettings, apiOk, dailyLimit: Number(settings.dailyLimit || DEFAULT_DAILY_LIMIT) };
}
